import React from 'react'
import Tr from 'translations/Translations';
import CloudDoneIcon from '@material-ui/icons/CloudDone';
import WorkableIconButton from "./WorkableIconButton";
import PropTypes from "prop-types";

function WorkableIconDownloadCountButton(
    {
        tooltip = Tr('download_count'),
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={CloudDoneIcon}
        {...props}
    />
}

WorkableIconDownloadCountButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconDownloadCountButton;